<template lang="pug">
select(
  class="form-control"
  v-on:change="onChange"
  v-bind:multiple="multiple"
)
  option( v-bind:value="null" v-bind:selected="! value" ) All
  template( v-for="country in countryCodes" )
    option(
      v-bind:value="country.value"
      v-bind:selected="value && multiple ? value.includes(country.value) : value === country.value"
      v-bind:disabled="country.disabled"
    ) {{ country.label }}

</template>

<style lang="scss">
select.form-control[multiple] {
  height: 200px;
}
</style>

<script>
import Vue from 'vue'
import { countryCodes } from '@/countryCodes'
export default Vue.extend({
  props: {
    value: [String, Array, null],
    multiple: Boolean,
  },
  data() {
    return {
      countryCodes,
    }
  },
  methods: {
    onChange(e) {
      if (this.multiple) {
        const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value)
        const allSelected = selectedOptions.includes('')
        if (allSelected) {
          e.target.selectedIndex = 0
          this.$emit('input', null)
        }
        else {
          this.$emit('input', selectedOptions)
        }
      }
      else {
        this.$emit('input', e.target.value)
      }
    },
  },
})
</script>